import { Link } from "react-router-dom";
import { Compass, ChevronRight } from "react-feather";
import { useT } from "@reciperoll/core";

// A tappable strip linking to the "What can I make?" screen — find recipes from
// the ingredients you already have. Mirrors the RN home component so both
// platforms surface it the same way.
export default function WhatCanIMake() {
  const t = useT();
  return (
    <Link
      to="/what-can-i-make"
      className="flex items-center gap-3 bg-terracotta hover:bg-terracotta-dark transition-colors rounded-2xl px-4 py-4 h-full"
    >
      <span className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center shrink-0">
        <Compass className="w-5 h-5 text-white" />
      </span>
      <span className="flex-1 min-w-0">
        <span className="block text-base font-bold text-white">{t("nav.whatCanIMake")}</span>
        <span className="block text-sm text-white/80">{t("home.whatCanIMakeSub")}</span>
      </span>
      <ChevronRight className="w-5 h-5 text-white/70 shrink-0" />
    </Link>
  );
}
